const NORTH_AMERICA = '888 482 7768';
const US_SPANISH_AND_ENGLISH = '857 829 5064';
export const DEFAULT_PHONE_NUMBER = '888 482 7768';
// Phone numbers are from here: https://www.hubspot.com/company/contact
const PHONE_NUMBERS = {
  de: {
    en: '+49 30 217998000',
    de: '+49 30 208486000'
  },
  'en-au': {
    en: '+61 2 9164 8000'
  },
  'en-ca': {
    en: NORTH_AMERICA
  },
  'en-gb': {
    en: '+44 20 7324 3700'
  },
  'en-ie': {
    en: '+353 1 518 7500'
  },
  'en-in': {
    en: DEFAULT_PHONE_NUMBER
  },
  'en-nz': {
    en: '+64 800 147 875'
  },
  'en-us': {
    en: NORTH_AMERICA
  },
  en: {
    en: NORTH_AMERICA
  },
  'es-ar': {
    en: US_SPANISH_AND_ENGLISH
  },
  'es-mx': {
    en: '+52 55 8877 6783',
    es: '+52 55 8877 6736'
  },
  es: {
    en: US_SPANISH_AND_ENGLISH
  },
  fi: {
    en: '+800 189362'
  },
  fr: {
    en: '+33 1 72 73 06 44',
    fr: '+33 1 72 73 05 00'
  },
  it: {
    en: DEFAULT_PHONE_NUMBER
  },
  ja: {
    ja: '+81 3 5656 5900'
  },
  nl: {
    en: '+31 20 200 3299'
  },
  'pt-br': {
    en: '+55 11 4700 3593',
    pt: '+55 11 4700 3592'
  },
  sv: {
    en: '+46 20 015 91 62'
  },
  'zh-cn': {
    en: DEFAULT_PHONE_NUMBER
  },
  'zh-hk': {
    en: '+852 3011 4980'
  }
};
export default PHONE_NUMBERS;